import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { key: 1 };
const _hoisted_2 = { class: "dropend" };
const _hoisted_3 = ["id"];
const _hoisted_4 = { class: "dropdown-menu" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MenuActionLink = _resolveComponent("MenuActionLink");
    return (_ctx.isAction(_ctx.menuData))
        ? (_openBlock(), _createBlock(_component_MenuActionLink, {
            key: 0,
            isTopLevel: false,
            menuData: _ctx.menuData
        }, null, 8, ["menuData"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("a", {
                        class: "dropdown-item dropdown-toggle pt-0",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false",
                        style: { "cursor": "pointer", "padding-bottom": "2px" },
                        id: 'menu2-' + _ctx.idSlug
                    }, _toDisplayString(_ctx.menuData.text) + "  ", 9, _hoisted_3),
                    _createElementVNode("ul", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getItems(_ctx.menuData), (item) => {
                            return (_openBlock(), _createBlock(_component_MenuActionLink, {
                                key: item.text,
                                isTopLevel: false,
                                menuData: item
                            }, null, 8, ["menuData"]));
                        }), 128))
                    ])
                ])
            ])
        ]));
}
